import axios from '../axiosSendLog';
import CommonUtils from '../utils/CommonUtils';
import { Random, Role } from '../utils';
// import { queueProcessCommon } from '../queueProcess'
import moment from 'moment';
import _ from 'lodash';
const globalVar = window._env_
const API_LOG_SERVICE = globalVar.api.API_LOG_SERVICE;
const configSendLog = globalVar.app.configSendLog || undefined;
const isSendLog = configSendLog && configSendLog.isSendLog || undefined;
const timerRetrySendLog = configSendLog && configSendLog.timerRetrySendLog || 10 * 1000;
const limitQueueLogs = configSendLog && configSendLog.limitQueueLogs || 200;
const timerDelay = configSendLog && configSendLog.timerDelay || 0;
const groupNumber = configSendLog && configSendLog.groupNumber || 0;
const usersLog = configSendLog && configSendLog.usersLog || [];

const TabID = CommonUtils.getTabID()
// const queueProcess = new queueProcessCommon()
// const queueTime = 0;
let queueLogs = [];
// const timer = 200;


function _addQueueLogs(obj) {
    if (queueLogs && queueLogs.length < limitQueueLogs) {
        let _index = _.findIndex(queueLogs, item => {
            return item.idLog == obj.idLog
        })
        if (_index == -1) {
            obj.countResend = 1
            queueLogs.push(obj)
        }
        else {
            if (queueLogs[_index].countResend == undefined) {
                queueLogs[_index].countResend = 1
            } else {
                queueLogs[_index].countResend = queueLogs[_index].countResend + 1
            }
        }
    }
}

function removeQueueByIdLog(idLog) {
    if (queueLogs && queueLogs.length > 0) {
        queueLogs = _.filter(queueLogs, queue => { return queue.idLog != idLog })
    }
}

function checkUserLog() {
    let sendLog = false;
    let currentCustodycd = CommonUtils.getCurrentCustodycd();

    if (usersLog && usersLog === 'ALL') { // ALL : Không chặn gửi log theo tài khoản (tất cả tài khoản)
        return true;
    }

    if (!currentCustodycd) { // Không lấy dc custodycd (chưa đăng nhập thì không gửi log)
        return false;
    }

    let currentRole = CommonUtils.getRole();

    if (usersLog && usersLog.length > 0 && currentCustodycd) {
        // Nếu key config bao gồm toàn bộ môi giới hoặc toàn bộ khách hàng phù hợp với role của user hiện tại ====> bắn log 
        if((usersLog.includes('ALL_BROKER') && currentRole === Role.BROKER) || (usersLog.includes('ALL_CUSTOMER') && currentRole === Role.CUSTOMER)){
            return true;
        }
        let foundIndex = _.findIndex(usersLog, item => { return item.toLowerCase() === currentCustodycd.toLowerCase() });
        sendLog = foundIndex >= 0;
    }
    return sendLog;
}

const sleep = m => new Promise(r => setTimeout(r, m));

const logger = {
    // Lấy dữ liệu cho đặt lệnh 
    info(msg) {
        if (isSendLog !== true) return null;
        let checkUser = checkUserLog();
        if (checkUser !== true) return null;
        let idLog = Random.randomIdChars(15)
        let timeLog = moment(new Date()).format('YYYY-MM-DD hh:mm:ss.SSS');
        msg.timeLog = timeLog
        msg.tabId = TabID
        msg.idLog = idLog
        let obj = {
            idLog,
            type: 'info',
            msg: JSON.stringify(msg)
        }
        // queueProcess.add(logger._executeSendLog, obj, queueTime)
        _addQueueLogs(obj)
    },
    error(msg) {
        if (isSendLog !== true) return null;
        let checkUser = checkUserLog();
        if (checkUser !== true) return null;
        let idLog = Random.randomIdChars(15)
        let timeLog = moment(new Date()).format('YYYY-MM-DD hh:mm:ss.SSS');
        msg.timeLog = timeLog
        msg.tabId = TabID
        msg.idLog = idLog
        let obj = {
            idLog,
            type: 'error',
            msg: JSON.stringify(msg)
        }
        // queueProcess.add(logger._executeSendLog, obj, queueTime)
        _addQueueLogs(obj)
    },
    debug(msg) {
        if (isSendLog !== true) return null;
        let checkUser = checkUserLog();
        if (checkUser !== true) return null;
        let idLog = Random.randomIdChars(15)
        let timeLog = moment(new Date()).format('YYYY-MM-DD hh:mm:ss.SSS');
        msg.timeLog = timeLog
        msg.tabId = TabID
        msg.idLog = idLog
        let obj = {
            idLog,
            type: 'debug',
            msg: JSON.stringify(msg)
        }
        // queueProcess.add(logger._executeSendLog, obj, queueTime)
        _addQueueLogs(obj)
    },

    async _executeSendLog(queueGroup) {
        _.map(queueGroup, (queue) => {
            if (queue.idLog) {
                removeQueueByIdLog(queue.idLog) // Remove luôn tránh bị gửi thừa log trùng nhau
            }
        })
        let timeSendLog = moment(new Date()).format('YYYY-MM-DD hh:mm:ss.SSS');
        let obj = {
            timeSendLog: timeSendLog,
            queueGroup: queueGroup,
        }
        // console.debug("_executeSendLog.: ", obj, queueGroup && queueGroup.length)
        let result = await axios.post(`${API_LOG_SERVICE}/sendLog`, obj).then((res) => {
            if (res && res.ec == 0) {
                // removeQueueByIdLog(obj.idLog)
                return true
            } else {
                //queue log
                _.map(queueGroup, (queue) => {
                    if (queue.idLog) {
                        _addQueueLogs(queue)
                    }
                })
                return false
            }
        }).catch(e => {
            //queue log
            _.map(queueGroup, (queue) => {
                if (queue.idLog) {
                    _addQueueLogs(queue)
                }
            })
            return false
        });
        return result


    },

    _retrySendQueueLogs() {
        setTimeout(async () => {
            let _queueLogs = _.cloneDeep(queueLogs)
            let queueLength = _queueLogs && _queueLogs.length
            if (queueLength > 0) {
                let countGroup = 0
                let queueGroup = []
                let count = 0
                for (let queue of _queueLogs) {
                    count++
                    countGroup++
                    queueGroup.push(queue)
                    if (countGroup == groupNumber || count == queueLength) {
                        let result = await logger._executeSendLog(queueGroup)
                        countGroup = 0
                        queueGroup = []
                        if (parseInt(timerDelay) > 0) {
                            await sleep(timerDelay)
                        }
                        // console.debug("_retrySendQueueLogs.:", res)
                        if (result == false) {
                            break;
                        }
                    }
                }
            }
            logger._retrySendQueueLogs()
        }, timerRetrySendLog)
    }

}
logger._retrySendQueueLogs();
export default logger;
